import React, { useState } from "react";
import PageWrapper from "./components/PageWrapper";
import { useFormCtx } from "./FormContext";
import { useRef } from "react";
import { IMaskInput } from "react-imask";
import Input from "./components/Input";
import Label from "./components/Label";
import * as Const from "./_Const";
import Keyboard from "./components/Keyboard";
import useMediaQuery from "./hooks/useMediaQuery";

function PagePersonalNumber({ onNext, onPrev }) {
  //sconst [value, setValue] = useState(0);
  const { getPageData, handleInputWithKeyboard, state, setCurrentStepIndex, isEmptyState, isInErrorState, welcomePageState } = useFormCtx();
  const index = Const.REG_RPI_PERSONAL_NUMBER_INDEX;
  const page = getPageData(index);

  // use ref to get access to internal "masked = ref.current.maskRef"
  const ref = useRef(null);
  const inputRef = useRef(null);
  const errorClass = state.errors.personalNumber ? "border-error-dark" : "border-accent";

  const isRpiScreen = useMediaQuery("(min-width: 1200px)");
  const textClass = isRpiScreen ? "text-4xl h-20" : "h-10";
  const showTitle = !Const.isTerminal();

  function canShowNext() {
    return state.personalNumber && !isInErrorState ? true : false;
  }

  function canShowSkip() {
    //je povoleno prskocit validaci a je chybovy stav
    return welcomePageState?.isPersonalNumberValidationSkipEnabled && !canShowNext() /*&& state.personalNumber*/ ? true : false;
  }
  return (
    <>
      <PageWrapper title={page.title} index={index} showTitle={showTitle} showNext={canShowNext()} showSkip={canShowSkip()} skipText="Neznám své Rodné číslo">
        <div className="mt-4 flex flex-col space-y-4 mx-6">
          <div className="flex flex-col">
            <label htmlFor="personalNumber" className="text-primary"></label>
            <Label label={"Rodné číslo"} name={"personalNumber"} errorMessage={state.errors.personalNumber} />
            <IMaskInput
              mask={"0000000000"}
              maxLength={10}
              value={state.personalNumber}
              unmask={true} // true|false|'typed'
              ref={ref}
              inputRef={inputRef}
              /*onAccept={(value, mask) => console.log(value)}*/
              name="personalNumber"
              id="personalNumber"
              placeholder="Vyplňte rodné číslo bez lomítka"
              autoComplete="off"
              readOnly={true}
              className={`border rounded-xl ${textClass} p-4 inset-shadow-xl focus:outline-none  selection:bg-accent-secondary selection:text-black  ${errorClass}`}
            />
          </div>

          <Keyboard type={"number"} onChange={(e) => handleInputWithKeyboard("personalNumber", e)} maxLen={10} />
        </div>
      </PageWrapper>
    </>
  );
}

export default PagePersonalNumber;
